<template>

    <div class="modal fade" id="modalAllTask" role="dialog" aria-labelledby="modalAllTaskLabel" tabindex="-1">
        <div class="modal-dialog modal-lg">
            <div class="modal-content rounded-3">
                <div class="modal-header bg-secondary text-white border-0" style="padding:1.12rem;">
                    <h5 class="modal-title" style="width: 75%;">
						<i class="ph-list icon-modal-size me-2"></i><span class="me-2">Task associate all'item</span>			
					</h5> 
					<button type="button" class="btn btn-light btn-sm btn-icon border-transparent rounded-pill" data-bs-dismiss="modal"><i class="ph-x icon-x-size"></i></button>
                </div>
                <div class="modal-body p-2" style="height: 33rem;"> 

                    <div v-if="arrayTaskByModulo.length > 0">
                        <div class="div_table_resp">
                            <table class="table table-bordered table-hover table-striped table-togglable text-nowrap">
			                    <thead class="sticky-top">
									<tr class="bg-secondary text-white">
                                        <th class="hidden-xs table-head-sm" style="width:2%"></th>
                                        <th class="hidden-xs table-head-sm" style="width:63%"> Titolo - Descrizione </th>
                                        <th class="hidden-xs table-head-sm" style="width:15%"> Scadenza </th>
                                        <th class="hidden-xs table-head-sm" v-if="$root.isGod" style="width:15%"> Utente </th>
                                        <th class="hidden-xs table-head-sm" style="width:20%;"> Azioni </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="task in arrayTaskByModulo" :key="task.ID_TASK">
                                        <td class="hidden-xs td-class text-center">
                                            <input type="checkbox" :checked="task.COMPLETATA == 1" @change="toggleCompletamentoItem(task, $event)" :disabled="task.COMPLETATA == 1 && !$root.isGod">
                                        </td>
                                        <td class="td-class fs-sm">
                                            <span class="text-primary text-uppercase fw-bold cursor-pointer"> {{ task.TITOLO }} </span>
                                            <i v-if="task.PROMEMORIA == 1" class="fa fa-bell text-warning ms-1"></i><br>
                                            <small> {{ task.DESCRIZIONE }} </small>
                                        </td>
                                        <td class="td-class fs-sm"> {{ filters.formatDate(task.DATA_SCADENZA) }} </td>
                                        <td class="td-class fs-sm" v-if="$root.isGod">
                                            {{task.UTENTI_ASSEGNATI.find(u => u.ID_UTENTE == task.FK_ID_UTENTE)?.USERNAME || '—'}}
                                        </td>
                                        <td class="td-class text-center">
                                            <div class="d-inline-flex" v-if="task.COMPLETATA == 0">
                                                <a class="cursor-pointer" @click="modificaTask(task)"><i class="fas fa-pencil fa-fw text-warning me-1"></i></a><span class="text-muted me-1">|</span>
                                                <a class="cursor-pointer" @click="gestisciPromemoria(task)"><i class="fas fa-bell text-teal fa-fw me-1"></i></a><span class="text-muted me-1">|</span>
                                                <a class="cursor-pointer" @click="eliminaTask(task)"><i class="fas fa-trash fa-fw text-danger"></i></a>
                                           </div>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                    <div v-else class="text-muted text-center py-3">
                        <p>
                            Non ci sono task associate a questo item.
                        </p>
                    </div>
                     
                </div>
                <div class="modal-footer bg-light p-1">
                    <button type="button" class="btn btn-link" data-bs-dismiss="modal">
						<i class="fal fa-sign-out-alt fa-fw me-2"></i><Translate :path="'dizionario.base.BTN_CLOSE'"></Translate>
					</button>
                    <button class="btn btn-info float-end" @click="creaTask()"><i class="fas fa-plus-square fa-fw me-2"></i> Crea Task</button>
                </div>
            </div>
        </div>
    </div>

    <ModalToDo ref="modalTodo" :task="taskSelezionata" :categories="arrayCategories" :arrayUtenti="arrayUtenti"
        @salva="salvaTask" @task-multipla-creata="$emit('taskMultiplaCreata')"></ModalToDo>
    <PromemoriaForm ref="promemoriaForm" :task="taskSelezionata" :utente="$root.utente" :modulo="modulo"
        @salvato="getTaskByModulo()" @eliminato="getTaskByModulo()"></PromemoriaForm>

</template>


<script>

import ModalToDo from './ModalToDo.vue';
import PromemoriaForm from './PromemoriaForm.vue';

export default {
    name: 'ModalAllTask',

    components: {
        ModalToDo, PromemoriaForm
    },

    emits:['taskMultiplaCreata'],

    props: {
        modulo: {
            type: Number,
            required: true,
        },
    },
    
    data() {
        return {
            filters: global.filters,
            arrayCategories: [],
            arrayTaskByModulo: [],
            taskSelezionata: {},
            idUtente: this.$root.utente.ID_UTENTE,
            idItem: 0,
            arrayUtenti: this.$root.arrayUtentiAdmin,
        };
    },
    methods: {
        gestisciPromemoria(task) {
            this.taskSelezionata = utils.clone(task);
            this.taskSelezionata.FK_ID_ITEM = this.idItem;
            this.$refs.promemoriaForm.openPromemoria(this.taskSelezionata);
        },
        apriModale(idItem) {
            this.idItem = idItem;
            this.getTaskByModulo();
            this.filters.openPopUp('modalAllTask');
        },
        getTaskByModulo() {
            utils.get('shared/task/get/by/modulo', { ID_UTENTE: this.idUtente, FK_ID_MODULO: this.modulo, FK_ID_ITEM: this.idItem }, (response) => {
                if (response.esito == 0) {
                    this.arrayTaskByModulo = response.data;
                } else {
                }
            });
        },
        loadCategorie(idUtente) {
            utils.get('shared/todo_categoria/get', { ID_UTENTE: idUtente }, (response) => {
                if (response.esito == 0) {
                    this.arrayCategories = response.data;
                }
            });
        },
        creaTask(arraySelezionati = [], modulo) {
            this.loadCategorie(this.idUtente);
            if(arraySelezionati.length > 0){
                this.taskSelezionata = { ID_TASK: 0, CONDIVISO: 0 , FK_ID_MODULO : modulo};
                this.$refs.modalTodo.createMoreTask(arraySelezionati,modulo);
            } else {
                this.taskSelezionata = {};
                this.$refs.modalTodo.createTask();
            }
        },
        modificaTask(task) {
            this.loadCategorie(this.idUtente);
            this.taskSelezionata = task;
            this.$refs.modalTodo.editTask();
        },
        eliminaTask(task) {
            utils.alert.confirm('Sei sicuro di voler eliminare questa task?', () => {
                utils.delete('shared/task/delete/by/modulo', { FK_ID_TASK: task.ID_TASK, FK_ID_MODULO: this.modulo, FK_ID_ITEM: this.idItem }, (response) => {
                    if (response.esito == 0) {
                        this.getTaskByModulo();
                        utils.alert.success("Task eliminata con successo");
                    } else {
                        utils.alert.danger("Errore durante l'eliminazione della task: " + response.messaggio);
                    }
                });
            }, this.$root);
        },
        salvaTask(task) {
            if (task.ID_TASK > 0) {
                utils.put('shared/task/update', task, (response) => {
                    if (response.esito == 0) {
                        this.$refs.modalTodo.closeModalToDo();
                        this.$emit('taskSalvata');
                        this.getTaskByModulo();
                        utils.alert.success("Task aggiornata con successo");
                        
                    } else {
                        utils.alert.danger("Errore durante l'aggiornamento della task: " + response.messaggio);
                    }
                });
            } else {
                // Create new task
                task.FK_ID_MODULO = this.modulo;
                task.FK_ID_ITEM = this.idItem;
                utils.ajax('shared/task/insert', task, (response) => {
                    if (response.esito == 0) {
                        this.$refs.modalTodo.closeModalToDo();
                        this.$emit('taskSalvata');
                        this.getTaskByModulo();
                        utils.alert.success("Task creata con successo");
                        
                    } else {
                        utils.alert.danger("Errore durante la creazione della task: " + response.messaggio);
                    }
                });
            }
        },

        toggleCompletamentoItem(task, event) {
            const nuovoStato = event.target.checked ? 1 : 0;
            const payload = {
                FK_ID_TASK: task.ID_TASK,
                FK_ID_MODULO: this.modulo,
                FK_ID_ITEM: this.idItem,
                COMPLETATA: nuovoStato,
                FK_ID_UTENTE: task.FK_ID_UTENTE,
            };

            utils.put('shared/task/item/completa', payload, (response) => {
                if (response.esito == 0) {
                    this.getTaskByModulo();
                    utils.alert.success("Task aggiornata correttamente per l'item");
                } else {
                    utils.alert.warning("Errore nel completamento della task: " + response.messaggio);
                }
            });
        }

    },

    created() {
        //this.loadCategorie(this.idUtente);

    }

}   
</script>
